<template>
  <div class="smaller-container-wrapper full-height no-progress-bar">
    <h2 class="pt-3 pt-sm-4 mb-3">{{ $t('message.eCommerceV2.finance.intro.heading') }}</h2>
    <p class="text-dark msg mb-4 pb-2" v-if="showPaymentDetails" data-test="paymentDetails">
      {{
        $t('message.eCommerceV2.finance.intro.msg', {
          terms: `${paymentTerm} ${$t('message.eCommerceV2.paymentCalculator.months')}`,
          period: $t(`message.eCommerceV2.paymentCalculator.${paymentPeriod}Period2`),
          paymentAmount: $n(paymentAmount, 'currencyDollars', languageCode),
        })
      }}
    </p>
    <ul class="list-unstyled" :class="{ 'pt-3': !showPaymentDetails }">
      <li class="mb-4" v-for="(item, index) in list" :key="index">
        <span class="primary-fill-svg">
          <inline-svg class="mr-2 mb-1" :src="require('@/assets/check-circle-blue-fill.svg')" alt="" />
        </span>
        {{ item }}
      </li>
    </ul>
    <div class="push-down-desktop">
      <mobialis-button
        @click="next"
        class="mt-5 mb-3"
        data-cy="getStarted"
        v-av-analytics-cta-interaction="{ elementText: $t('message.common.getStarted'), eventActionResult: 'open' }"
        >{{ $t('message.common.getStarted') }}</mobialis-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { PaymentMethod } from '@/utils/enums';

export default {
  name: 'FinanceIntro',
  data() {
    return {
      list: this.$t('message.eCommerceV2.finance.intro.list'),
    };
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      paymentAmount: 'paymentCalculator/currentPaymentAmount',
      paymentTerm: 'paymentCalculator/currentPaymentTerm',
    }),
    ...mapState('paymentCalculator', ['paymentPeriod', 'paymentMethod']),
    showPaymentDetails() {
      return this.paymentMethod === PaymentMethod.FINANCE || this.paymentMethod === PaymentMethod.LEASE;
    },
  },
  methods: {
    next() {
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped>
.msg {
  font-size: 18px;
  line-height: 24px;
}
@media (min-width: 575px) {
  .msg {
    font-size: 20px;
    line-height: 26px;
  }
}
</style>
